import React from "react";
import { Icon } from "@chakra-ui/react";

export function ProbabilisticSvg() {
  return (
    <Icon width="100%" height="auto" viewBox="0 0 912 640" fill="none">
      <path d="M156.996 414.569L427.246 551.609" stroke="#40DE9E" strokeWidth="2.25" />
      <path d="M373.227 424.539L438.994 533.522" stroke="#40DE9E" strokeWidth="2.25" />
      <path d="M161 400L287.738 386.803" stroke="#40DE9E" strokeWidth="2.25" />
      <path d="M517 153L649 97" stroke="#40DE9E" strokeWidth="2.25" />
      <path d="M598.511 373.351L710 242" stroke="#40DE9E" strokeWidth="2.25" />
      <g id="blue-lines">
        <path className="blue-line" d="M130.738 344.276L205.512 181.401" stroke="#3498DA" strokeWidth="2.25" />
        <path className="blue-line" d="M420 182L262 152" stroke="#3498DA" strokeWidth="2.25" />
        <path className="blue-line" d="M816 346L768 254" stroke="#3498DA" strokeWidth="2.25" />
      </g>
      <g id="orange-lines">
        <path className="orange-line" d="M374.442 332.057L442.311 234.975" stroke="#F9BA3E" strokeWidth="2.25" />
        <path className="orange-line" d="M396.636 387.137L507.751 408.8" stroke="#F9BA3E" strokeWidth="2.25" />
      </g>
      <circle cx="684.957" cy="76.1593" r="42.1875" transform="rotate(-160.066 684.957 76.1593)" fill="#2D71DC" />
      <circle
        opacity="0.7"
        cx="684.958"
        cy="76.1596"
        r="42.1875"
        transform="rotate(-119.874 684.958 76.1596)"
        fill="url(#paint0_linear_11217_5980)"
      />
      <g className="blue-node">
        <circle cx="221.457" cy="142.533" r="42.1875" transform="rotate(64.2879 221.457 142.533)" fill="#2D71DC" />
        <circle
          cx="221.458"
          cy="142.532"
          r="42.1875"
          transform="rotate(158.227 221.458 142.532)"
          fill="url(#paint1_linear_11217_5980)"
        />
        <circle
          opacity="0.5"
          cx="221.456"
          cy="142.533"
          r="42.1875"
          transform="rotate(-176.239 221.456 142.533)"
          fill="url(#paint2_linear_11217_5980)"
        />
      </g>
      <circle cx="744.581" cy="219.035" r="42.1875" transform="rotate(-160.066 744.581 219.035)" fill="#2D71DC" />
      <circle
        cx="744.58"
        cy="219.036"
        r="42.1875"
        transform="rotate(158.258 744.58 219.036)"
        fill="url(#paint3_linear_11217_5980)"
      />
      <circle
        opacity="0.7"
        cx="744.583"
        cy="219.034"
        r="42.1875"
        transform="rotate(-118.496 744.583 219.034)"
        fill="url(#paint4_linear_11217_5980)"
      />
      <circle cx="839.082" cy="381.035" r="42.1875" transform="rotate(-160.066 839.082 381.035)" fill="#2D71DC" />
      <circle
        cx="839.081"
        cy="381.035"
        r="42.1875"
        transform="rotate(-42.8912 839.081 381.035)"
        fill="url(#paint5_linear_11217_5980)"
      />
      <circle cx="465.549" cy="565.534" r="42.1875" transform="rotate(-160.066 465.549 565.534)" fill="#2D71DC" />
      <circle
        cx="465.549"
        cy="565.535"
        r="42.1875"
        transform="rotate(-66.1269 465.549 565.535)"
        fill="url(#paint6_linear_11217_5980)"
      />
      <circle
        opacity="0.5"
        cx="465.551"
        cy="565.533"
        r="42.1875"
        transform="rotate(-40.5927 465.551 565.533)"
        fill="url(#paint7_linear_11217_5980)"
      />
      <circle cx="105.376" cy="394.358" r="56.25" transform="rotate(30 105.376 394.358)" fill="#2D71DC" />
      <circle
        opacity="0.7"
        cx="105.374"
        cy="394.361"
        r="56.25"
        transform="rotate(89.1399 105.374 394.361)"
        fill="url(#paint8_linear_11217_5980)"
      />
      <circle
        opacity="0.7"
        cx="105.374"
        cy="394.361"
        r="56.25"
        transform="rotate(28.9178 105.374 394.361)"
        fill="url(#paint9_linear_11217_5980)"
      />
      <circle cx="475.499" cy="189.609" r="56.25" transform="rotate(30 475.499 189.609)" fill="#2D71DC" />
      <circle
        opacity="0.7"
        cx="475.499"
        cy="189.611"
        r="56.25"
        transform="rotate(30 475.499 189.611)"
        fill="url(#paint10_linear_11217_5980)"
      />
      <circle
        opacity="0.7"
        cx="475.497"
        cy="189.611"
        r="56.25"
        transform="rotate(-73.6286 475.497 189.611)"
        fill="url(#paint11_linear_11217_5980)"
      />
      <circle
        className="orange-gradient"
        opacity="0.4"
        cx="475.498"
        cy="189.611"
        r="56.25"
        transform="rotate(-149.138 475.498 189.611)"
        fill="url(#paint12_linear_11217_5980)"
      />
      <circle cx="342.751" cy="377.485" r="56.25" transform="rotate(43.9241 342.751 377.485)" fill="#2D71DC" />
      <circle
        opacity="0.5"
        cx="342.748"
        cy="377.487"
        r="56.25"
        transform="rotate(-106.322 342.748 377.487)"
        fill="url(#paint13_linear_11217_5980)"
      />
      <circle
        opacity="0.4"
        cx="342.749"
        cy="377.486"
        r="56.25"
        transform="rotate(155.682 342.749 377.486)"
        fill="url(#paint14_linear_11217_5980)"
      />
      <circle
        className="orange-gradient"
        opacity="0.4"
        cx="342.749"
        cy="377.486"
        r="56.25"
        transform="rotate(59.044 342.749 377.486)"
        fill="url(#paint15_linear_11217_5980)"
      />
      <circle cx="563.253" cy="416.858" r="56.25" transform="rotate(30 563.253 416.858)" fill="#2D71DC" />
      <circle
        opacity="0.7"
        cx="563.251"
        cy="416.86"
        r="56.25"
        transform="rotate(30 563.251 416.86)"
        fill="url(#paint16_linear_11217_5980)"
      />
      <circle
        className="orange-gradient"
        opacity="0.7"
        cx="563.25"
        cy="416.861"
        r="56.25"
        transform="rotate(-73.188 563.25 416.861)"
        fill="url(#paint17_linear_11217_5980)"
      />
      <g className="blue-text-group">
        <path
          id="blue-text-border"
          d="M133.342 209.684C133.342 208.579 134.237 207.684 135.342 207.684H271.342C272.446 207.684 273.342 208.579 273.342 209.684V233.684C273.342 234.788 272.446 235.684 271.342 235.684H135.342C134.237 235.684 133.342 234.788 133.342 233.684V209.684Z"
          fill="#02131B"
          stroke="#3498DA"
          strokeWidth="2.5"
          mask="url(#path-38-inside-1_11217_5980)"
        />
        <path
          id="blue-text"
          d="M149.207 225.85H147.623V216.32H149.207V220.372H154.025V216.32H155.609V225.85H154.025V221.798H149.207V225.85ZM159.321 217.244H157.855V215.343H159.321V217.244ZM159.321 225.85H157.855V218.3H159.321V225.85ZM164.373 225.666C162.393 225.666 160.967 224.108 160.967 221.864C160.967 219.62 162.393 218.036 164.399 218.036C165.442 218.036 166.327 218.485 166.894 219.264V218.3H168.373V224.834C168.373 227.461 167 228.913 164.558 228.913C162.789 228.913 161.575 228.16 161.02 226.735L162.248 225.89C162.433 226.946 163.291 227.619 164.531 227.619C165.983 227.619 166.894 226.656 166.894 225.085V224.293C166.393 225.151 165.455 225.666 164.373 225.666ZM164.69 224.372C166.01 224.372 166.894 223.356 166.894 221.824C166.894 220.333 166.01 219.33 164.69 219.33C163.37 219.33 162.472 220.333 162.472 221.838C162.472 223.356 163.383 224.372 164.69 224.372ZM171.88 225.85H170.415V215.713H171.88V219.488C172.474 218.564 173.438 218.036 174.613 218.036C176.315 218.036 177.319 219.171 177.319 220.966V225.85H175.853V221.244C175.853 220.016 175.193 219.343 174.177 219.343C172.804 219.343 171.88 220.544 171.88 222.339V225.85ZM186.497 226.101C184.24 226.101 182.656 224.491 182.656 222.062C182.656 219.633 184.226 218.036 186.523 218.036C188.239 218.036 189.533 218.934 190.021 220.518L188.516 221.125C188.305 219.99 187.553 219.33 186.484 219.33C185.098 219.33 184.16 220.412 184.16 222.062C184.16 223.725 185.111 224.808 186.484 224.808C187.54 224.808 188.292 224.161 188.516 223.026L190.021 223.62C189.533 225.19 188.213 226.101 186.497 226.101ZM195.058 226.101C192.774 226.101 191.23 224.491 191.23 222.075C191.23 219.646 192.774 218.036 195.058 218.036C197.315 218.036 198.86 219.633 198.86 222.075C198.86 224.491 197.315 226.101 195.058 226.101ZM195.058 224.808C196.404 224.808 197.355 223.712 197.355 222.075C197.355 220.425 196.404 219.33 195.058 219.33C193.685 219.33 192.735 220.425 192.735 222.075C192.735 223.712 193.685 224.808 195.058 224.808ZM201.962 225.85H200.497V218.3H201.962V219.448C202.57 218.564 203.533 218.036 204.695 218.036C206.398 218.036 207.401 219.171 207.401 220.966V225.85H205.936V221.244C205.936 220.042 205.315 219.343 204.272 219.343C202.9 219.343 201.962 220.557 201.962 222.339V225.85ZM212.931 219.541H211.4V225.85H209.935V219.541H208.839V218.3H209.935V217.851C209.935 216.386 210.701 215.462 212.087 215.462C212.588 215.462 213.09 215.607 213.367 215.871L213.103 216.874C212.918 216.69 212.681 216.571 212.351 216.571C211.809 216.571 211.321 216.967 211.387 218.181V218.3H212.931V219.541ZM216.107 217.244H214.642V215.343H216.107V217.244ZM216.107 225.85H214.642V218.3H216.107V225.85ZM221.226 226.101C219.18 226.101 217.754 224.464 217.754 222.075C217.754 219.739 219.259 218.036 221.252 218.036C222.374 218.036 223.325 218.564 223.879 219.435V215.713H225.344V225.85H223.879V224.636C223.311 225.586 222.361 226.101 221.226 226.101ZM221.569 224.808C222.915 224.808 223.879 223.686 223.879 222.075C223.879 220.425 222.902 219.33 221.556 219.33C220.196 219.33 219.259 220.438 219.259 222.062C219.259 223.699 220.209 224.808 221.569 224.808ZM230.828 226.101C228.531 226.101 226.973 224.491 226.973 222.075C226.973 219.633 228.518 218.036 230.801 218.036C233.19 218.036 234.616 219.765 234.444 222.445H228.531C228.518 223.844 229.468 224.847 230.814 224.847C231.884 224.847 232.676 224.24 232.94 223.21L234.26 223.791C233.718 225.256 232.464 226.101 230.828 226.101ZM230.801 219.29C229.574 219.29 228.702 220.082 228.584 221.27H232.913C232.821 220.069 232.002 219.29 230.801 219.29ZM237.577 225.85H236.111V218.3H237.577V219.448C238.184 218.564 239.147 218.036 240.309 218.036C242.012 218.036 243.015 219.171 243.015 220.966V225.85H241.55V221.244C241.55 220.042 240.929 219.343 239.887 219.343C238.514 219.343 237.577 220.557 237.577 222.339V225.85ZM248.44 226.101C246.183 226.101 244.599 224.491 244.599 222.062C244.599 219.633 246.17 218.036 248.466 218.036C250.182 218.036 251.476 218.934 251.964 220.518L250.46 221.125C250.248 219.99 249.496 219.33 248.427 219.33C247.041 219.33 246.104 220.412 246.104 222.062C246.104 223.725 247.054 224.808 248.427 224.808C249.483 224.808 250.235 224.161 250.46 223.026L251.964 223.62C251.476 225.19 250.156 226.101 248.44 226.101ZM257.027 226.101C254.731 226.101 253.173 224.491 253.173 222.075C253.173 219.633 254.717 218.036 257.001 218.036C259.39 218.036 260.816 219.765 260.644 222.445H254.731C254.717 223.844 255.668 224.847 257.014 224.847C258.083 224.847 258.875 224.24 259.139 223.21L260.459 223.791C259.918 225.256 258.664 226.101 257.027 226.101ZM257.001 219.29C255.773 219.29 254.902 220.082 254.783 221.27H259.113C259.021 220.069 258.202 219.29 257.001 219.29Z"
          fill="#3498DA"
        />
      </g>

      <g className="orange-text-group">
        <path
          id="orange-text-border"
          d="M359.342 281.684C359.342 280.579 360.237 279.684 361.342 279.684H497.342C498.446 279.684 499.342 280.579 499.342 281.684V305.684C499.342 306.788 498.446 307.684 497.342 307.684H361.342C360.237 307.684 359.342 306.788 359.342 305.684V281.684Z"
          fill="#02131B"
          stroke="#F9BA3E"
          strokeWidth="2.5"
          mask="url(#path-40-inside-2_11217_5980)"
        />
        <path
          id="orange-text"
          d="M375.099 297.85V288.32H376.683V296.425H381.541V297.85H375.099ZM386.482 298.101C384.198 298.101 382.654 296.491 382.654 294.075C382.654 291.646 384.198 290.036 386.482 290.036C388.739 290.036 390.284 291.633 390.284 294.075C390.284 296.491 388.739 298.101 386.482 298.101ZM386.482 296.808C387.828 296.808 388.779 295.712 388.779 294.075C388.779 292.425 387.828 291.33 386.482 291.33C385.109 291.33 384.159 292.425 384.159 294.075C384.159 295.712 385.109 296.808 386.482 296.808ZM393.703 297.85L391.367 290.3H392.924L393.571 292.584C393.914 293.772 394.39 295.567 394.561 296.266H394.588C394.759 295.567 395.208 293.785 395.525 292.57L396.145 290.3H397.624L398.257 292.57C398.508 293.428 398.996 295.408 399.221 296.266H399.247C399.472 295.408 399.986 293.428 400.224 292.57L400.871 290.3H402.349L400.079 297.85H398.416L397.888 295.95C397.465 294.432 397.082 293.032 396.871 292.135H396.845C396.634 293.032 396.277 294.432 395.855 295.95L395.327 297.85H393.703ZM411.019 298.101C408.762 298.101 407.178 296.491 407.178 294.062C407.178 291.633 408.749 290.036 411.046 290.036C412.762 290.036 414.055 290.934 414.544 292.518L413.039 293.125C412.828 291.99 412.075 291.33 411.006 291.33C409.62 291.33 408.683 292.412 408.683 294.062C408.683 295.725 409.633 296.808 411.006 296.808C412.062 296.808 412.815 296.161 413.039 295.026L414.544 295.62C414.055 297.19 412.735 298.101 411.019 298.101ZM419.581 298.101C417.297 298.101 415.753 296.491 415.753 294.075C415.753 291.646 417.297 290.036 419.581 290.036C421.838 290.036 423.382 291.633 423.382 294.075C423.382 296.491 421.838 298.101 419.581 298.101ZM419.581 296.808C420.927 296.808 421.877 295.712 421.877 294.075C421.877 292.425 420.927 291.33 419.581 291.33C418.208 291.33 417.257 292.425 417.257 294.075C417.257 295.712 418.208 296.808 419.581 296.808ZM426.485 297.85H425.02V290.3H426.485V291.448C427.092 290.564 428.056 290.036 429.217 290.036C430.92 290.036 431.923 291.171 431.923 292.966V297.85H430.458V293.244C430.458 292.042 429.838 291.343 428.795 291.343C427.422 291.343 426.485 292.557 426.485 294.339V297.85ZM437.454 291.541H435.923V297.85H434.457V291.541H433.362V290.3H434.457V289.851C434.457 288.386 435.223 287.462 436.609 287.462C437.111 287.462 437.612 287.607 437.889 287.871L437.625 288.874C437.441 288.69 437.203 288.571 436.873 288.571C436.332 288.571 435.843 288.967 435.909 290.181V290.3H437.454V291.541ZM440.63 289.244H439.165V287.343H440.63V289.244ZM440.63 297.85H439.165V290.3H440.63V297.85ZM445.748 298.101C443.702 298.101 442.277 296.464 442.277 294.075C442.277 291.739 443.782 290.036 445.775 290.036C446.897 290.036 447.847 290.564 448.402 291.435V287.713H449.867V297.85H448.402V296.636C447.834 297.586 446.884 298.101 445.748 298.101ZM446.092 296.808C447.438 296.808 448.402 295.686 448.402 294.075C448.402 292.425 447.425 291.33 446.078 291.33C444.719 291.33 443.782 292.438 443.782 294.062C443.782 295.699 444.732 296.808 446.092 296.808ZM455.35 298.101C453.053 298.101 451.496 296.491 451.496 294.075C451.496 291.633 453.04 290.036 455.324 290.036C457.713 290.036 459.138 291.765 458.967 294.445H453.053C453.04 295.844 453.99 296.847 455.337 296.847C456.406 296.847 457.198 296.24 457.462 295.21L458.782 295.791C458.241 297.256 456.987 298.101 455.35 298.101ZM455.324 291.29C454.096 291.29 453.225 292.082 453.106 293.27H457.436C457.343 292.069 456.525 291.29 455.324 291.29ZM462.099 297.85H460.634V290.3H462.099V291.448C462.706 290.564 463.67 290.036 464.831 290.036C466.534 290.036 467.537 291.171 467.537 292.966V297.85H466.072V293.244C466.072 292.042 465.452 291.343 464.409 291.343C463.036 291.343 462.099 292.557 462.099 294.339V297.85ZM472.962 298.101C470.705 298.101 469.121 296.491 469.121 294.062C469.121 291.633 470.692 290.036 472.989 290.036C474.705 290.036 475.998 290.934 476.487 292.518L474.982 293.125C474.771 291.99 474.018 291.33 472.949 291.33C471.563 291.33 470.626 292.412 470.626 294.062C470.626 295.725 471.576 296.808 472.949 296.808C474.005 296.808 474.758 296.161 474.982 295.026L476.487 295.62C475.998 297.19 474.678 298.101 472.962 298.101ZM481.55 298.101C479.253 298.101 477.696 296.491 477.696 294.075C477.696 291.633 479.24 290.036 481.524 290.036C483.913 290.036 485.338 291.765 485.167 294.445H479.253C479.24 295.844 480.19 296.847 481.537 296.847C482.606 296.847 483.398 296.24 483.662 295.21L484.982 295.791C484.441 297.256 483.187 298.101 481.55 298.101ZM481.524 291.29C480.296 291.29 479.425 292.082 479.306 293.27H483.636C483.543 292.069 482.725 291.29 481.524 291.29Z"
          fill="#F9BA3E"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_11217_5980"
          x1="684.958"
          y1="33.9721"
          x2="684.958"
          y2="72.2221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11217_5980"
          x1="221.458"
          y1="100.345"
          x2="221.458"
          y2="138.595"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3498DA" />
          <stop offset="1" stopColor="#3498DA" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11217_5980"
          x1="221.456"
          y1="100.345"
          x2="221.456"
          y2="138.595"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3498DA" />
          <stop offset="1" stopColor="#3498DA" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_11217_5980"
          x1="744.58"
          y1="176.848"
          x2="744.58"
          y2="215.098"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3498DA" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_11217_5980"
          x1="744.584"
          y1="176.846"
          x2="744.584"
          y2="215.096"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_11217_5980"
          x1="839.081"
          y1="338.847"
          x2="839.081"
          y2="377.097"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3498DA" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_11217_5980"
          x1="465.549"
          y1="523.347"
          x2="465.549"
          y2="561.597"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_11217_5980"
          x1="465.551"
          y1="523.346"
          x2="465.551"
          y2="561.596"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_11217_5980"
          x1="105.374"
          y1="338.111"
          x2="105.374"
          y2="389.111"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_11217_5980"
          x1="105.374"
          y1="338.111"
          x2="105.374"
          y2="389.111"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3498DA" />
          <stop offset="1" stopColor="#3498DA" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_11217_5980"
          x1="475.499"
          y1="133.361"
          x2="475.499"
          y2="184.361"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_11217_5980"
          x1="475.497"
          y1="133.361"
          x2="475.497"
          y2="184.361"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3498DA" />
          <stop offset="1" stopColor="#3498DA" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_11217_5980"
          x1="475.498"
          y1="133.361"
          x2="475.498"
          y2="184.361"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9BA3E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_11217_5980"
          x1="342.748"
          y1="321.237"
          x2="342.748"
          y2="372.237"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_11217_5980"
          x1="342.749"
          y1="321.236"
          x2="342.749"
          y2="372.236"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_11217_5980"
          x1="342.749"
          y1="321.236"
          x2="342.749"
          y2="372.236"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9BA3E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_11217_5980"
          x1="563.251"
          y1="360.61"
          x2="563.251"
          y2="411.61"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40DE9E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_11217_5980"
          x1="563.25"
          y1="360.611"
          x2="563.25"
          y2="411.611"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9BA3E" />
          <stop offset="1" stopColor="#2D71DC" stopOpacity="0" />
        </linearGradient>
      </defs>
    </Icon>
  );
}
